import { UserKeys, UserState } from '../../state/reducers/userReducer'

export const getProfileData = (state: { user: UserState }) =>
  state.user[UserKeys.profile].data
